import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import {DashboardWidgetModule} from './dashboard-widget/dashboard-widget.module';
import {TabModule} from '../tab/tab.module';
import {DashboardToolbarModule} from './dashboard-toolbar/dashboard-toolbar.module';
import {TractorsPerDomainWidgetModule} from './widgets/tractors-per-domain-widget/tractors-per-domain-widget.module';
import {ExamplePieWidgetModule} from './widgets/example-pie-widget/example-pie-widget.module';
import {ExampleBarWidgetModule} from './widgets/example-bar-widget/example-bar-widget.module';
import {ExampleNumberWidgetModule} from './widgets/example-number-widget/example-number-widget.module';
import {ExampleGridWidgetModule} from './widgets/example-grid-widget/example-grid-widget.module';
import {TractorsAvgAgePerDomainWidgetModule} from './widgets/tractors-avg-age-per-domain-widget/tractors-avg-age-per-domain-widget.module';
import {TractorsEnginePowerPerHectareWidgetModule} from './widgets/tractors-engine-power-per-hectare-widget/tractors-engine-power-per-hectare-widget.module';
import {TractorsHectaresPerTractorWidgetModule} from './widgets/tractors-hectares-per-tractor-widget/tractors-hectares-per-tractor-widget.module';
import {NumberWidgetModule} from './widgets/number-widget/number-widget.module';
import {TractorsProximityWidgetModule} from './widgets/tractors-proximity-widget/tractors-proximity-widget.module';
import {TractorsFuelConsumptionWidgetModule} from './widgets/tractors-fuel-consumption-widget/tractors-fuel-consumption-widget.module';



@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardWidgetModule,
    TabModule,
    DashboardToolbarModule,
    TractorsPerDomainWidgetModule,
    ExamplePieWidgetModule,
    ExampleBarWidgetModule,
    ExampleNumberWidgetModule,
    ExampleGridWidgetModule,
    TractorsAvgAgePerDomainWidgetModule,
    TractorsEnginePowerPerHectareWidgetModule,
    TractorsHectaresPerTractorWidgetModule,
    NumberWidgetModule,
    TractorsProximityWidgetModule,
    TractorsFuelConsumptionWidgetModule
  ],
  exports: [DashboardComponent]
})
export class DashboardModule { }
